

























































import Vue from 'vue'
import { mapState, mapGetters } from 'vuex'
import { Chart } from 'highcharts-vue'
import moment from 'moment'

import { IStateActivity } from '@/store/modules/activity'
import { IStateComposite } from '@/store/modules/composite'
import { IStateThing } from '@/store/modules/thing'
import { APIMotionStatus } from '@/type/things/motion/status'

interface IStatusComponent {
  date: string
  duration: string
  current: {
    motion: boolean | null
    humanMotion: boolean | null
    tsMs: number
  }
}

export default Vue.extend({
  data(): IStatusComponent {
    return {
      date: moment(Date.now()).format('HH:mm:ss'),
      duration: '0 sec',
      current: {
        motion: null,
        humanMotion: null,
        tsMs: moment().valueOf()
      }
    }
  },
  computed: {
    ...mapState<IStateActivity>('activity', {
      motionStatus: (state: IStateActivity) => state.motionStatus
    }),
    ...mapGetters('composite', ['compositesConnected'])
  },
  watch: {
    motionStatus: function(motionStatus: APIMotionStatus) {
      if (!motionStatus || !motionStatus.timestamp) return

      const previousMotion = this.current
      const currentTsMs = Date.parse(motionStatus.timestamp)
      const currentHumanMotion = motionStatus.humanMotionDetected
      const currentMotion = motionStatus.motionDetected

      if (previousMotion.humanMotion !== currentHumanMotion || previousMotion.motion !== currentMotion) {
        this.duration = '1 sec'
        this.date = moment(currentTsMs).format('HH:mm:ss')
        this.current = {
          motion: currentMotion,
          humanMotion: currentHumanMotion,
          tsMs: currentTsMs
        }
      } else {
        const fromDate = previousMotion.tsMs
        const toDate = currentTsMs

        let secs = Math.round((toDate - fromDate) / 1000)
        if (secs === 0) secs = 1
        this.duration = secs <= 59 ? `${secs} sec` : `${Math.floor(secs / 60)} mn ${secs % 60} sec`
      }
    }
  },
  mounted() {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        this.date = moment(Date.now()).format('HH:mm:ss')
        this.duration = '0 sec'
        this.current = {
          motion: null,
          humanMotion: null,
          tsMs: moment().valueOf()
        }
      }
    })
  }
})
